import images from '@assets/images/index'

import { useAppQueryString } from '@suntex.fim/nav'
import { Rankings as _Rankings } from '@suntex.fim/rankings'

function Rankings() {
  const queryString = useAppQueryString()

  return (
    <_Rankings
      images={{ topTen: images.Top10Awards }}
      searchParams={queryString}
    />
  )
}

export default Rankings
